import CurrentUser from '@get-bridge/learn-legacy-shared/dist/entities/CurrentUser';
import { toastOfError } from '@get-bridge/learn-legacy-packages.bridge-toaster';
import I18n from '@get-bridge/learn-legacy-shared/dist/shimmed_modules/I18n';
import { updateProfile as updateProfileRequest } from '@get-bridge/learn-legacy-shared/dist/data_requests/learner';
import { omitBy } from 'lodash';
import changePassword from 'data_requests/changePassword';
import S3Upload from '@get-bridge/learn-legacy-shared/dist/core/S3Upload';
import ProfileStore from '@get-bridge/learn-legacy-shared/dist/stores/ProfileStore';
import AuthStore from '@get-bridge/learn-legacy-shared/dist/stores/AuthStore';
import LocaleStore from '@get-bridge/learn-legacy-shared/dist/stores/LocaleStore';
import { THEME_HIGH_CONTRAST } from 'constants';
import Promise from 'Promise';
import * as locationUtils from '../utils/location';

const STORAGE_KEY = 'learnerActionsUpdateProfileA11y';

function updateLocale(locale) {
  LocaleStore.setIsUpdatingLocale(true);

  ProfileStore.update({ locale }).then(
    () => {
      CurrentUser.updateLocale(locale);
      locationUtils.reload();
    },
    () => {
      toastOfError(
        I18n.t(
          'Oh Snap! We were unable to update your language settings. Please try again later.',
        ),
      );
    },
  );
}

function updatePassword(oldPassword, newPassword) {
  return AuthStore.applyBridgeRefreshTokenToCall(
    changePassword,
    oldPassword,
    newPassword,
  );
}

function failedToUpdatePrefsToast() {
  toastOfError(
    I18n.t(
      'Oh Snap! We were unable to update your preferences. Please try again later.',
    ),
  );
}

function updateA11y(enabled) {
  updateProfileRequest({ a11y: enabled }).then(
    () => {
      storeSettings({ a11y: enabled });
      CurrentUser.updateA11y(enabled);
    },
    () => {
      storeSettings(null);
      CurrentUser.updateA11y(!enabled);
      failedToUpdatePrefsToast();
    },
  );
}

function updateHCM(theme) {
  ProfileStore.update({ theme }).then(
    () => {
      CurrentUser.updateTheme(theme);
    },
    () => {
      CurrentUser.updateTheme(!theme ? THEME_HIGH_CONTRAST : null);
      failedToUpdatePrefsToast();
    },
  );
}

function updateUnderlineLinks(enabled) {
  ProfileStore.update({ underlineLinks: enabled }).then(
    () => {
      CurrentUser.updateUnderlineLinks(enabled);
    },
    () => {
      CurrentUser.updateUnderlineLinks(!enabled);
      failedToUpdatePrefsToast();
    },
  );
}

function storeSettings(settings) {
  window.localStorage[STORAGE_KEY] = JSON.stringify(settings);
}

function updateProfile(newAttrs, oldAttrs) {
  const changes = omitBy(newAttrs, (v, k) => {
    return oldAttrs[k] === v;
  });

  for (const key in changes) {
    const value = changes[key];
    switch (key) {
      case 'locale':
        updateLocale(value);
        break;
      case 'a11y':
        updateA11y(value);
        break;
      case 'theme':
        updateHCM(value);
        break;
      case 'underlineLinks':
        updateUnderlineLinks(value);
        break;
      case 'avatarUrl':
        updateAvatarURL(value);
        break;
      default:
        throw new Error(`Not Implemented: profile: ${key}`);
    }
  }

  // Some codepaths in BUC expect this update to return a Promise, and
  // fail to attach their callbacks otherwise.
  return Promise.resolve();
}

function updateAvatarURL(avatarUrl) {
  CurrentUser.updateAvatarURL(avatarUrl);

  return updateProfileRequest({ avatarUrl }).catch(() => {
    toastOfError(
      I18n.t(
        'Oh Snap! We were unable to update your avatar. Please try again later.',
      ),
    );
  });
}

function uploadFile(file) {
  const uploader = S3Upload(file, { public: true });

  return uploader.upload().then(
    response => {
      updateAvatarURL(response.location);
    },
    e => {
      console.error('Failed to upload image: ', file, e);
    },
  );
}

function getSelectedApp({ pathname }) {
  if (pathname.startsWith('/insights')) {
    return 'insights';
  } else if (
    pathname.startsWith('/support') ||
    pathname.startsWith('/admin') ||
    pathname.startsWith('/admin/markets') ||
    pathname.startsWith('/admin/users') ||
    pathname.startsWith('/author/learner') ||
    pathname.startsWith('/author/groups') ||
    pathname.startsWith('/author/data-dump')
  ) {
    return 'admin';
  } else if (pathname.startsWith('/author')) {
    return 'author';
  }
  return 'career';
}

export default {
  updateProfile,
  updatePassword,
  uploadFile,
  getSelectedApp,
};



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/shared/Actions.js